import { GetPacksRequest, PackResource } from '@foxbun/lib-goferal-types';
import { AbstractModelStore, AbstractModelStoreOptions } from './abstract/AbstractModelStore';
import { PackModel } from '../../models/PackModel';
import { ObjectId } from 'bson';
import { ProfileStore } from './ProfileStore';
import { action } from 'mobx';

export interface PackStoreOptions extends AbstractModelStoreOptions {
  user_store: () => ProfileStore;
}

export class PackStore extends AbstractModelStore<PackModel, PackResource> {
  constructor(protected options2: PackStoreOptions) {
    super(options2);
  }

  @action async getPacks(req: GetPacksRequest) {
    let packs = await this.client.packs.getPacks(req).call();
    return packs.items.map((i) => {
      return this.ensureModel(i._id, i);
    });
  }

  protected generateModel(id: ObjectId, data: PackResource | undefined): PackModel {
    return new PackModel({
      api_client: this.client,
      id: id,
      data: data,
      user_store: this.options2.user_store()
    });
  }

  async getProfilePacks(id: ObjectId) {
    let results = await this.client.profile.getProfilePacks({
      _id: id
    });
    return results.map((r) => {
      return this.ensureModel(r._id, r);
    });
  }
}
